export default {
  'price-vendor': ['price_vendor_management']
}
